/**
 * @author zjc[beica1@outook.com]
 * @date 2021/9/6 14:25
 * @description
 *   request.js of wetrade.www
 */
import * as R from 'ramda'

export const jsonp = (url, data) => {
  return new Promise((resolve, reject) => {
    const callback = 'callback_' + Math.random().toString(36).slice(2)

    const script = document.createElement('script')

    const remove = () => {
      delete (window)[callback]
      try {
        document.body.removeChild(script)
      } catch(e) {
        // console.log('err')
      }
    }
    (window)[callback] = (resp) => {
      resolve(resp)
      remove()
    }

    const dataStr = R.pipe(R.toPairs, R.map(R.join('=')), R.join('&'))(data || {})

    script.src = url + '?callback=' + callback + '&' + dataStr

    script.onerror = () => {
      reject()
      remove()
    }

    document.body.appendChild(script)
  })
}



// WEBPACK FOOTER //
// ./src/utils/request.js